import { FailureHandlingAction, JobObjectFailure } from '../../../interfaces/job';
import { Button } from '../../../../button/Button';
import { useActionsHandler } from '../../../../action-handler/useActionsHandler';
import { ActionStatus, ActionType } from '../../../../action-handler/action-handler.service';
import { JobsAPI } from '../../../JobsAPI';
import { downloader } from '../../../../action-handler/downloader';
import { GenericStatusLabel } from '../../../../shared/components/GenericStatusLabel/GenericStatusLabel';
import { GenericStatusColorType } from '../../../../shared/interfaces/generic-status';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { JobsTrackers } from '../../../jobs-trackers';

const JobStageFailureActionMetaData = {
  [FailureHandlingAction.DOWNLOAD_FILE]: FailureHandlingDownloadFile
};

interface JobStageFailureActionProps {
  id: string;
}

export function JobObjectStageFailureActions({ failure }: { failure: JobObjectFailure }) {
  const { id, actions } = failure;

  return (
    <>
      {(actions || []).map(action => {
        const Component = JobStageFailureActionMetaData[action];
        return <Component key={action} id={id} />;
      })}
    </>
  );
}

function FailureHandlingDownloadFile({ id }: JobStageFailureActionProps) {
  const { eventTrack } = useAnalyticsTracker();

  const actionId = `job-object-stage-failure-download-${id}`;

  const { status, performAction, abortAction } = useActionsHandler(actionId, ActionType.DOWNLOAD, {
    progressTitle: `Downloading error file for #${id}`,
    failureTitle: `Error file download failed for #${id}`
  });

  const inProgress = status.status === ActionStatus.IN_PROGRESS;

  return (
    <div className='center-flex-row'>
      {inProgress ? (
        <GenericStatusLabel
          className='mr-2'
          status={{
            displayName: 'Downloading',
            icon: 'testing',
            value: null,
            colorType: GenericStatusColorType.INFO
          }}
        />
      ) : null}
      <Button
        icon={inProgress ? 'close' : 'download'}
        variation='outline'
        size='sm'
        dataId={id}
        onClick={() => {
          if (inProgress) {
            eventTrack({
              action:
                JobsTrackers.JOB_TRACKER_JOB_OBJECT_STAGE_FAILURE_DETAILS_DOWNLOAD_CANCEL_CLICK,
              properties: {
                jobId: id
              }
            });

            abortAction();
            return;
          }

          eventTrack({
            action: JobsTrackers.JOB_TRACKER_JOB_OBJECT_STAGE_FAILURE_DETAILS_DOWNLOAD_CLICK,
            properties: {
              jobId: id
            }
          });

          performAction(
            downloader(
              () => JobsAPI.downloadFailureFile(id),
              'application/zip',
              `failure-handling-details-${id}.zip`
            )
          );
        }}
      >
        {inProgress ? 'Cancel' : 'Download Events'}
      </Button>
    </div>
  );
}
